import { createReducer, on, Action } from '@ngrx/store';
import * as categoriesActions from '../actions/delivery-time-categories.actions';
import { DeliveryTimeCategoryApiModel } from 'app/models/delivery-time-category-api.model';

export interface State {
  categories: DeliveryTimeCategoryApiModel[];
  isLoading: boolean;
  isReady: boolean;
}

export const initialState: State = {
  categories: [],
  isLoading: false,
  isReady: false,
};

export const featureReducer = createReducer(
  initialState,
  on(categoriesActions.loadDeliveryTimeCategories, (state: State) => ({
    ...state,
    isLoading: true,
    isReady: false,
  })),
  on(
    categoriesActions.loadDeliveryTimeCategoriesSuccess,
    (state: State, { response }) => ({
      ...state,
      isLoading: false,
      isReady: true,
      categories: response,
    })
  ),
  on(categoriesActions.loadDeliveryTimeCategoriesFailed, (state: State) => ({
    ...state,
    isLoading: false,
    isReady: false,
  }))
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
